import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { sanitizeData } from "@l2r-front/l2r-geodata"
import { Source } from "@l2r-front/l2r-map"
import { useNetworkReferential } from "@l2r-front/l2r-networks"

export function DocumentAttachedObjectSource(props) {

    const { road } = useParams()
    const { data: roadFeature } = useNetworkReferential({ linear_location_road: road }, { enabled: !!road, as_geojson: true })

    const sanitizedData = useMemo(() => {
        return sanitizeData(roadFeature)
    }, [roadFeature])

    if (!sanitizedData) {
        return null
    }

    return (
        <Source {...props} type="geojson" data={sanitizedData} tolerance={.001} />
    )
}